import React from "react";
import cx from "classnames";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import ChartReferralNextVisit from "./referral-next-visit/ChartReferralNextVisit";

const useStyles = makeStyles(() => ({
  container: {
    position: "absolute",
    width: "100vw",
    height: "100vh",
    top: 0,
    right: 0,
    background: "rgba(0, 0, 0, .5)",
    zIndex: 1099,
  },
  formContent: {
    position: "absolute",
    height: "100%",
    right: 0,
    top: 0,
    zIndex: 1100,
    backgroundColor: "#fff",
  },
}));

const ChartReferralNextVisitSidebar = () => {
  const classes = useStyles();
  const { referralNextVisitModalVisible } = useSelector((store) => store.chart);
  if (!referralNextVisitModalVisible) return null;

  return (
    <div className={classes.container}>
      <div className={cx("chart-referral-next-visit-form-sidebar", classes.formContent)}>
        <ChartReferralNextVisit />
      </div>
    </div>
  );
};

export default ChartReferralNextVisitSidebar;
